module.exports = __webpack_public_path__ + "static/media/boomer_admin_items.6ec6d2d5.png";